export default "__VITE_ASSET__y9q0$8YB__"